import { init as initApm } from '@elastic/apm-rum'

export const apmRum = initApm({
    serviceName: process.env.NEXT_PUBLIC_ELASTIC_APM_SERVICE_NAME, // Nome da aplicação
    serverUrl: process.env.NEXT_PUBLIC_ELASTIC_APM_SERVER_URL, // URL do servidor APM    
    environment: process.env.NODE_ENV, // Ambiente (ex.: development, production)
    //secretToken: process.env.ELASTIC_APM_SECRET_TOKEN, // Token, se necessário,
    //verifyServerCert: false,
    //usePathAsTransactionName: true,
    //logLevel : 'error',    
    distributedTracingOrigins: [
      'http://localhost:3000',  // Domínio local (durante desenvolvimento)
      'https://*.posconsumer.com', // API do servidor em sandbox
      'https://*.menudino.com', // API do servidor em produção
      'https://*.menudino.com.br', // API do servidor em produção
    ]
    //captureHeaders: true, // Captura os cabeçalhos para rastreamento
  });

  //export default apmRum;